// frontend/src/pages/ForgotPasswordPage.js
import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import api from '../api'

const font = "'Noto Serif JP', Georgia, serif"
const ink = '#1A0A00'
const muted = '#8A7A5A'
const accent = '#C41E3A'

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [submitted, setSubmitted] = useState(false)

  const handleSubmit = async e => {
    e.preventDefault()
    setLoading(true)
    try {
      await api.post('/auth/forgot-password', { email })
    } catch {
      // swallow — always show success
    } finally {
      setLoading(false)
      setSubmitted(true)
    }
  }

  return (
    <div style={s.page}>
      <div style={s.card}>
        <Link to="/login" style={s.back}>← Back to sign in</Link>

        <div style={s.sealWrap}>
          <div style={s.seal}><span style={s.sealText}>相撲{'\n'}番付</span></div>
        </div>

        <div style={s.logoArea}>
          <h1 style={s.logoText}>Reset Password</h1>
          <p style={s.tagline}>Sumo Pick'em</p>
        </div>

        {submitted ? (
          <p style={s.success}>
            If an account exists for that email, you'll receive a reset link shortly.
          </p>
        ) : (
          <form onSubmit={handleSubmit} style={s.form}>
            <div style={s.field}>
              <label style={s.label}>Email address</label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                autoFocus
                style={s.input}
                placeholder="your@email.com"
              />
            </div>
            <button type="submit" disabled={loading} style={s.btn}>
              {loading ? 'Sending…' : 'Send reset link'}
            </button>
          </form>
        )}
      </div>
    </div>
  )
}

const s = {
  page: {
    minHeight: '100vh',
    background: '#F5F0E8',
    backgroundImage: 'repeating-linear-gradient(0deg, transparent, transparent 3px, rgba(180,160,120,0.06) 3px, rgba(180,160,120,0.06) 4px)',
    display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20,
  },
  card: {
    background: '#FFFFFF', border: '1px solid #D4C8A8', borderRadius: 4,
    padding: '40px 36px', width: '100%', maxWidth: 380,
    boxShadow: '0 4px 24px rgba(42,26,14,0.08)', position: 'relative',
  },
  back: {
    position: 'absolute', top: 18, left: 22,
    color: muted, textDecoration: 'none', fontFamily: font, fontSize: 12, letterSpacing: 1,
  },
  sealWrap: { textAlign: 'center', marginBottom: 12 },
  seal: {
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
    width: 48, height: 48, background: accent, borderRadius: 4,
  },
  sealText: {
    color: '#F5F0E8', fontSize: 9, fontWeight: 700, textAlign: 'center',
    lineHeight: 1.3, whiteSpace: 'pre', fontFamily: font,
  },
  logoArea: { textAlign: 'center', marginBottom: 28 },
  logoText: { fontFamily: font, fontSize: 22, fontWeight: 900, color: ink, margin: '0 0 4px' },
  tagline: { color: muted, fontFamily: font, fontSize: 12, margin: 0, letterSpacing: 1 },
  form: { display: 'flex', flexDirection: 'column', gap: 14 },
  field: { display: 'flex', flexDirection: 'column', gap: 5 },
  label: { fontSize: 10, color: muted, fontFamily: font, letterSpacing: 1, textTransform: 'uppercase' },
  input: {
    padding: '10px 12px', background: '#FDFBF7',
    border: '1px solid #D4C8A8', borderRadius: 2,
    color: ink, fontSize: 14, fontFamily: font, outline: 'none',
    width: '100%', boxSizing: 'border-box',
  },
  btn: {
    padding: '12px', background: accent, color: '#F5F0E8',
    border: 'none', borderRadius: 2, fontSize: 11, fontWeight: 700,
    fontFamily: font, cursor: 'pointer', letterSpacing: 3, textTransform: 'uppercase',
    marginTop: 4,
  },
  success: {
    color: '#1A6A1A', fontFamily: font, fontSize: 13, lineHeight: 1.6,
    background: '#F0FAF0', border: '1px solid #A8D4A8',
    borderRadius: 3, padding: '14px 16px', margin: 0,
  },
}
